module.exports = __webpack_public_path__ + "media/images/icons/eye-closed-alt-099ac6709faa7b9435f7a1f0c0fcb679.png";